import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const ItemWrapper = styled.div<any>`
  background: ${props => props.theme.palette.general.strong};
  color: ${props => props.theme.palette.general.light};
  border-radius: 4px;
  overflow: hidden;
  text-align: center;
  min-height: 172px;

  p {
    font-size: 14px;
    margin: 0;
  }

  .item {
    &__loading {
      width: 100%;
      height: 170px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__main {
      padding: 16px 8px 14px;
    }

    &__bottom {
      background: ${props => props.theme.palette.general.strongMutted};
      padding: 8px 8px 12px;
    }

    &__price {
      font: ${font('default', 'bold', '30px/1.2')};
      margin-top: 6px;
    }

    &__tag {
      padding: 10px 0;
    }

    &__free-shipping {
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }
  }
`
